import _ from "lodash";
/**
 * Temporary route to redirect old route to the new one
 * To be deleted in the future
 */
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";

const OLD_CLASS_FLOW_ROUTE = "class-materials";
const NEW_CLASS_FLOW_ROUTE = "class-flow";

export default store => ({
  path: OLD_CLASS_FLOW_ROUTE,
  onEnter(nextState, replace) {
    const { location: { pathname } = {} } = nextState;
    const newPath = _.replace(
      pathname,
      OLD_CLASS_FLOW_ROUTE,
      NEW_CLASS_FLOW_ROUTE
    );

    replace(newPath);
  },
  childRoutes: [ClassRoomDetails(store)],
});
